(function () {
  var CARD_SELECTOR = '.ef-coll-card';
  var ADD_SELECTOR = '[data-add]';
  var NOTIFY_SELECTOR = '[data-notify-url]';

  function markCartIndicatorVisible() {
    document.querySelectorAll('.cart-icon-indicator, .site-header__cart-indicator, [data-cart-count]').forEach(function (el) {
      el.classList.remove('hide');
    });
  }

  function showSuccessToast() {
    if (window.theme && window.theme.Notify && typeof window.theme.Notify.open === 'function') {
      window.theme.Notify.open('success', false, true);
      return;
    }
    if (window.Notify && typeof window.Notify.open === 'function') {
      window.Notify.open('success', false, true);
    }
  }

  function quickAdd(variantId, button) {
    var payload = new URLSearchParams();
    payload.set('id', variantId);
    payload.set('quantity', '1');

    // Brand-context display title (curated ef_collection_titles value) so the
    // cart can echo the name the shopper actually saw. Hidden at checkout (_ prefix).
    var displayTitle = button.getAttribute('data-display-title');
    if (displayTitle) {
      payload.set('properties[_ef_display_title]', displayTitle);
    }

    button.disabled = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: payload.toString()
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data && data.description ? data.description : 'Unable to add item to cart.');
          });
        }
        return response.json();
      })
      .then(function () {
        showSuccessToast();
        markCartIndicatorVisible();
      })
      .catch(function (error) {
        if (window.theme && window.theme.Notify && typeof window.theme.Notify.open === 'function') {
          window.theme.Notify.open('error', error.message, true);
        } else {
          window.alert(error.message);
        }
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function navigateToCard(url, event) {
    if (!url) return;
    // The card link is JS-driven, so replicate the "open in new tab/window" affordances
    // that ctrl/cmd/shift/middle-click would give a real <a> (otherwise they are swallowed).
    if (event && (event.metaKey || event.ctrlKey || event.button === 1)) {
      window.open(url, '_blank', 'noopener');
    } else if (event && event.shiftKey) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  }

  function onCardClick(event) {
    var isPrimary = event.type === 'click' && (event.button === 0 || event.button === undefined);
    var isMiddle = event.button === 1;
    if (!isPrimary && !isMiddle) return;

    if (isPrimary) {
      var addButton = event.target.closest(ADD_SELECTOR);
      if (addButton) {
        event.preventDefault();
        event.stopPropagation();

        var variantId = addButton.getAttribute('data-variant-id');
        if (variantId) {
          quickAdd(variantId, addButton);
        }
        return;
      }

      var notifyButton = event.target.closest(NOTIFY_SELECTOR);
      if (notifyButton) {
        event.preventDefault();
        event.stopPropagation();

        var notifyUrl = notifyButton.getAttribute('data-notify-url');
        if (notifyUrl) {
          window.location.href = notifyUrl;
        }
        return;
      }
    }

    var card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    // Real links/buttons keep native behavior (incl. new-tab on the overlay
    // <a class="ef-coll-card__hit">); only the non-interactive JS path needs the shim.
    var isInteractive = event.target.closest('a, button, input, select, textarea, label, [role="button"]');
    if (isInteractive) return;

    navigateToCard(card.getAttribute('data-product-url'), event);
  }

  function init() {
    if (!document.querySelector(CARD_SELECTOR)) return;
    document.addEventListener('click', onCardClick);
    // Middle-click ("open in new tab") dispatches auxclick, not click.
    document.addEventListener('auxclick', onCardClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
